import './EventFormSelection.scss';

import {compose} from 'redux';
import React from 'react';

import {connectEvent, connectI18n} from '../../../connects';
import Header from './Header';
import Link from '../../../elements/Link';
import Screen from '../../Screen';
import Scrollable from '../../../elements/Scrollable';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import Validate from '../../../validate/Validate';
import VerticalCenter from '../../../elements/VerticalCenter';
import tinycolor from 'tinycolor2';

class EventFormSelection extends React.Component {
    render() {
        let {event, i18n} = this.props,
            forms = event.forms,
            title = forms[0].choicescreen_title || i18n['label.your-requests'],
            logoURL = forms[0].logo_url,
            iconURL = forms[0].icon_url,
            header = (
                <div className="formsHeader">
                    <TopBarEvent event={event}>{title}</TopBarEvent>
                    <Header background={logoURL} icon={iconURL} />
                </div>
            );

        return (
            <Screen className="EventFormSelection" header={header}>
                <Scrollable>
                    <VerticalCenter>
                        {forms.map(form => {
                            let backgroundColor = form.button_color || event.settings.primary_color || '#fff';

                            return (
                                <Link
                                    key={form.id}
                                    href={'./' + form.id + '/create'}
                                    className={['eventButton', tinycolor(backgroundColor).isLight() ? 'light-bg' : 'dark-bg'].join(' ')}
                                    type="button"
                                    style={{
                                        backgroundColor,
                                    }}>
                                    <span className="title">{form.button_title}</span>
                                    <span className="text">{form.button_subtitle}</span>
                                </Link>
                            );
                        })}
                    </VerticalCenter>
                </Scrollable>
            </Screen>
        );
    }
}

const ConnectedScreen = compose(
    connectEvent,
    connectI18n
)(EventFormSelection);

export default props => (
    <Validate
        validate={state => {
            if (!_(state).get(`events[${props.match.params.eventId}].event.forms`, []).length) {
                throw new Error('No forms in event', props.match.params.eventId);
            }
        }}>
        <ConnectedScreen {...props.match.params} />
    </Validate>
);
